<template>
    <div class="mt-3">
        <div class="alert alert-danger" v-if="!item && status">
            {{ status }}
        </div>

        <az-loading v-if="!item && !status" />        

        <div class="container" v-else-if="item">

            <div class="bg-dark text-white alert lead mb-3">
                {{ item.unidade_operacao ? item.unidade_operacao.st_nome : unidade.search }}
            </div>

            <div class="alert alert-info">
                {{ item.nome_paciente }}
                <div class="small" v-if="laboratorio">
                    {{ laboratorio.toUpperCase() }}
                </div>
            </div>

            <p>Credenciais para envio de resultados:</p>

            <div v-if="atualizado">

                <div class="card">
                    <div class="card-body text-center">
                        <i class="fa fa-check-circle-o text-success fa-7x mb-3" aria-hidden="true"></i>
                        <h2>Resultado enviado com sucesso!</h2>
                    </div>
                </div>

            </div>

            <div v-else>

                <div>
                    <az-input
                        :edicao="!loading"
                        ref="login"
                        label="Login"
                        v-model="credenciais.login" />
                </div>
                <div>
                    <az-input
                        :edicao="!loading"
                        label="Senha"
                        v-model="credenciais.senha" />
                </div>
                
                <div class="d-flex flex-column mt-3">
                    <button type="button" class="btn btn-primary" :disabled="loading" @click="atualizar()">
                        <div class="spinner-border spinner-border-sm mr-2" role="status" v-if="loading">
                          <span class="sr-only">Loading...</span>
                        </div>
                        Enviar
                    </button>
                </div>

                <div class="alert alert-danger mt-3" v-if="status">
                    {{ status }}
                </div>

            </div>

            <Toast :baseZIndex="99999" />
        </div>
    </div>
</template>

<script>
import AzInput from '../shared/forms/AzInput.vue';
import AzLoading from '../util/AzLoading.vue';

export default {
    data() { 
        return { 
            dados: null, 
            item: null, 
            credenciais: { 
                login: "",
                senha: "",
            },
            unidade: null,
            atualizado: false,
            msg_erro: "", 
            status: "", 
            mtoken: "", 
        }
    },

    components: { 
        AzInput, 
        AzLoading,
    },

    computed: { 
        loading: function () { 
            return this.$store.state.loading;
        },
    },

    props: ['laboratorio', 'id', 'token'],

    methods: { 
        load() { 
            this.axios
                .post("/reembolso/dados", { tipo: 'm', id: this.id, token: this.token })
                .then(res => {
                    if (res.response && res.response.status > 400) {
                        this.status = res.response.data.msg;
                        this.$toast.add({
                            severity: "error",
                            summary: "Atenção",
                            detail: res.response.data.msg,
                            life: 3000
                        });
                    } else {
                        this.item = res.data.item;
                        this.unidade = res.data.unidade;
                        this.mtoken = res.data.token;
                        
                        this.$nextTick(() => { 
                            this.$refs['login'].$refs.input.focus ();
                        });
                    }
                })
                .catch(err => {
                    alert(err);
                })
                .finally(() => {
                    this.$store.commit("loading", false);
                });
        },

        atualizar() { 
            this.status = "";
            this.$store.commit("loading", true);

            this.axios
                .post("/resultados/importar", { 
                    laboratorio: this.laboratorio, 
                    id: this.id, 
                    token: this.mtoken,
                    ...this.credenciais, 
                })
                .then(res => {
                    if (res.response && res.response.status > 400) {
                        this.status = res.response.data.msg;
                        this.handleError(res);

                        this.$toast.add({
                            severity: "error",
                            summary: "Atenção",
                            detail: res.response.data.msg,
                            life: 3000
                        });
                    } else {
                        this.atualizado = true;
                    }
                })
                .catch(err => {
                    console.log(2, err.response);
                    alert(err);
                })
                .finally(() => {
                    this.$store.commit("loading", false);
                });
        }
    },

    mounted () {
        this.load(); 
    }
}
</script>